__turbopack_context__.v({
  "area-disclaimer": "style-module-scss-module__m_Exoa__area-disclaimer",
  "component": "style-module-scss-module__m_Exoa__component",
  "courtesy": "style-module-scss-module__m_Exoa__courtesy",
  "disclaimer": "style-module-scss-module__m_Exoa__disclaimer",
});
